import React, { useState, useEffect, useContext } from 'react';

import Questionnaire from '../course/Questionnaire';
import ServiceContext from "../WebService/ServiceContext";
import { HibModal } from "../course/HibModal";
import { ExamContext } from '../context/ExamContext'
import { BasicContext } from '../context/BasicContext'
import '../course/type.d.ts'


type ExamQuestProps = {
    examID: number
}

export default (props: ExamQuestProps) => {
    const ec = useContext(ExamContext)
    const bc = useContext(BasicContext)
    const ws = useContext(ServiceContext)
    const [open, setOpen] = useState<boolean>(false)
    const [mesg, setMesg] = useState<string>("")
    const [mesgOpen, setMesgOpen] = useState<boolean>(false)
    const [examID, setExamID] = useState<number>(props.examID)
    const [quests, setQuests] = useState<QuestRes[]>([])
    const [isComplete, setIsComplete] = useState<boolean>(true)
    /*
    useEffect(() => {
        console.log(ec)
    }, [ec.examInfo])

    useEffect(() => {
        console.log(bc)
    }, [bc])
    useEffect(() => {
        console.log(quests)
    }, [quests])
    */

    useEffect(() => {
        ws.WebService.asyncGetQuestionnaire(examID)
            .then(res => {
                setQuests(res as QuestRes[])
                return ws.WebService.asyncGetAnswer(bc.ActID, examID)
            })
            .then(res => {
                bc.setAnsList(res as ResAnswers[])
            })

        return
    }, [])

    const AnswerMyQ = (): Promise<boolean> => {
        let sn: number = 0;
        return new Promise((resolve, reject) => {
            const doAnswer = (): boolean => {
                if ((bc.ansList[sn]?.ItemID || bc.ansList[sn]?.ItemTxt) && bc.ansList[sn]?.QSNo) {
                 
                    ws.WebService.asyncAnswerQuestionnaire(
                        examID,
                        bc.ActID,
                        parseInt(bc.ansList[sn].QSNo),
                        bc.ansList[sn].ItemID ? bc.ansList[sn].ItemID : undefined,
                        bc.ansList[sn].ItemTxt ? bc.ansList[sn].ItemTxt : undefined,
                    ).then(res => {
                        sn++
                        //console.log(bc.ansList.length, sn)
                        if (bc.ansList.length != sn) {    
                            doAnswer()
                        } else {
                            sn = 0
                            resolve(true)
                        }
                    })
                }
                return true
            }

            bc.ansList.length != quests.length ?
                resolve(false)
                :
                doAnswer()
        })
    }

    return (
        <>
            <div className='exam-info'>
                {
                    quests.length > 0 &&
                    <div className="quests">
                        <Questionnaire
                            quests={quests}
                            cardData={{} as CardProps}
                            ansList={bc.ansList}
                            isComplete={((complete: boolean) => {
                                setIsComplete(complete)
                            })}
                        />
                    </div>
                }
                {
                    <button
                        className="hibBtn main full large"
                        disabled={isComplete}
                        onClick={() => {
                            //setOpenConfirmWithQuest(true)
                            setOpen(true)
                        }}
                    >送出</button>

                }
            </div>

            <HibModal
                type="notice"
                show={open}
                showCross={true}
                confirm={() => {
                    AnswerMyQ()
                    .then(res => {
                        console.log(res)
                        if (res) {
                            setOpen(false)
                            setMesgOpen(true)
                            setMesg("問卷填寫完成")
                        }else{
                            setMesg("問卷填寫失敗")
                        }
                    })
                }}
                cancel={() => {
                    setOpen(false)
                }}
            >
                {

                    bc.ansList &&
                    bc.ansList.length > 0 &&
                    <>
                    <div className="confirmAnsList">
                        您填寫的問卷如下：
                        {
                            bc.ansList.map((item: ResAnswers, index: number) => {
                                if (item.ItemID && item.ItemID != "") {
                                    return (
                                        <div className="ansList" key={"ansList" + index}>
                                            <div className="quest">
                                                Q{index + 1}. {item.qtxt}
                                            </div>
                                            <div className="answer">
                                                {item.ansTxt}
                                            </div>
                                        </div>
                                    )
                                }
                                else if (item.ItemTxt) {
                                    return (
                                        <div className="ansList" key={"ansList" + index}>
                                            <div className="quest">
                                                Q{index + 1}. {item.qtxt}
                                            </div>
                                            <div className="answer">
                                                {item.ItemTxt}
                                            </div>
                                        </div>
                                    )
                                }
                            })
                        }
                    </div>
                    <span>確認是否送出</span>
                    </>
                }
            </HibModal>

            <HibModal
                type="message"
                show={mesgOpen}
                showCross={true}
                confirm={() => {
                    location.reload()
                }}
                confirmText="關閉"
            >
                {mesg}
            </HibModal>

        </>
    )
}

